import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import Input from './common/Input'
import Select from './common/Select'
import ServerError from './common/ServerError'
import { usePostRequest } from '../hooks/request'
import { BILLING_INVOICE_GENERATE } from '../urls'
import { required } from '../utils/validators'

const MODULES = [
    { id: '', name: 'Все модули' },
    { id: 'zero', name: 'Nollik' },
    { id: 'manthly', name: 'Oylik' },
]

/** `YYYY-MM` -> bir oy oldingi `YYYY-MM`. */
function previousMonth(period) {
    const [year, month] = period.split('-').map(Number)
    const date = new Date(year, month - 2, 1)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}`
}

/**
 * Oy ochish formasi.
 *
 * Oy istalgani bo'lishi mumkin — kelajak oy ham (predoplata uchun). Summalar
 * boshqa oydan ko'chirilishi mumkin, shunda har oyda qaytadan kiritish shart emas.
 */
export default function ContractMonthOpen({ period, periods = [], onSuccess, onCancel }) {
    const generate = usePostRequest({ url: BILLING_INVOICE_GENERATE })

    // Nusxa olish uchun manba: mavjud oylar (bo'lmasa — o'tgan oy).
    const sourceOptions = [
        { id: '', name: 'Не копировать (суммы из договора)' },
        ...(periods.length ? periods : [previousMonth(period)]).map((m) => ({ id: m, name: m })),
    ]

    async function onSubmit(data) {
        const { success, response } = await generate.request({
            data: {
                period: data.period,
                ...(data.copyFrom ? { copy_from: data.copyFrom } : {}),
                ...(data.module ? { module: data.module } : {}),
            },
        })

        if (success) onSuccess(response, data.period)
    }

    const defaultSource = periods.find((m) => m !== period) || previousMonth(period)

    return (
        <div>
            <b>Открыть месяц</b>
            <p className="has-text-grey is-size-7">
                Для всех активных компаний будут созданы строки. Повторный запуск ничего
                не дублирует: добавятся только недостающие компании.
            </p>
            <br />
            <ServerError error={generate.error} />

            <Formik
                onSubmit={onSubmit}
                initialValues={{ period, copyFrom: defaultSource, module: '' }}>
                <Form>
                    <Input
                        name="period"
                        type="month"
                        label="Месяц"
                        validate={required}
                        help="Можно открыть и будущий месяц — например для предоплаты." />

                    <Select
                        name="copyFrom"
                        label="Скопировать суммы из месяца"
                        options={sourceOptions}
                        empty={false}
                        help="Если у компании есть строка в выбранном месяце — сумма возьмётся оттуда." />

                    <Select name="module" label="Модуль" options={MODULES} />

                    <Button
                        loading={generate.loading}
                        text="Открыть"
                        type="submit"
                        icon="ion-md-checkmark"
                        className="is-success" />
                    &nbsp;
                    <Button onClick={onCancel} text="Отмена" icon="ion-md-close" className="is-danger" />
                </Form>
            </Formik>
        </div>
    )
}
